module.exports = __webpack_public_path__ + "static/media/yale-nus.053371eb.png";